export default theme => ({
    container: {
        margin: '2em'
    },
    paginationContainer: {
        textAlign: 'right'
    }
})